<template>
  <div class="bg-card bg-white border-card-border md:px-6">
    <div class="w-full mt-10 mb-6">
      <div>
        <h1 slot="header" class="text-xl font-semibold pb-2">Agree to check your rate</h1>
        <h3 slot="header" class="pb-3 border-b mb-4"></h3>
      </div>
      <!-- <p class="text-gray-800 sm:pt-1 mb-6">
        Please authorize VIVA Finance Inc. to pull your credit and bankruptcy information.
        <span class="text-gray-800 font-bold"
          >Your credit history does not affect your ability to take out a loan with VIVA
          Finance*.</span
        >
      </p> -->
      <div class="py-4">
        <div class="mb-6">
          <div class="flex leading-none">
            <button
              aria-label="checkbox"
              type="button"
              id="prequal-auth-agree-button"
              class="mt-1 flex-none border border-gray-500 bg-gray-300 w-4 h-4 focus:outline-none focus:border-primary flex items-center justify-center mr-2"
              @click="terms.rateConsent = !terms.rateConsent"
            >
              <i v-if="terms.rateConsent" class="fas fa-check text-sm font-bold text-green-500"></i>
            </button>
            <p class="text-xs leading-7 md:text-base">
              By checking the box and clicking “Check My Rate” below you agree to the following:
            </p>
          </div>
        </div>

        <div class="mb-10">
          <div class="flex-col items-start leading-none">
            <li class="text-xs leading-7 md:text-base">
              You understand that you are providing ‘written instructions’ to Viva Finance, Inc.
              (“VIVA”) under the Fair Credit Reporting Act authorizing VIVA to obtain information
              from your personal credit profile or other information from Experian.
            </li>
            <li class="text-xs leading-7 md:text-base">
              You authorize VIVA to obtain such information solely to prequalify you for a VIVA
              loan. You authorize VIVA to initiate a “soft pull” of your credit, which will not
              affect your credit score;
            </li>
            <li class="text-xs leading-7 md:text-base">
              You understand that this loan inquiry is not an application for credit unless and
              until you choose to proceed with any loan offer.
            </li>
          </div>
        </div>
        <div class="flex w-full mt-4">
          <button
            class="hover:text-primary mr-auto focus:outline-none rounded"
            type="btn"
            id="prequal-auth-back-button"
            aria-label="navigate back"
            v-on:click="$emit('back')"
          >
            <i
              class="fas fa-arrow-left bg-gray-300 rounded-full flex items-center text-lg justify-center w-8 h-8"
            ></i>
          </button>

          <base-button
            :class="` ${!consented ? 'opacity-50' : ''}`"
            type="primary ml-auto"
            :disabled="!consented && !sucessUpdate"
            aria-label="navigate next"
            :loading="calcPrequalRate"
            id="prequal-auth-next-button"
            @click="handleNext()"
          >
            Check My Rate
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthPrequal',
  data: function () {
    return {
      terms: {
        rateConsent: false
      },
      prequalified: false,
      calcPrequalRate: false
    }
  },
  props: ['update'],
  computed: {
    consented() {
      return this.terms.rateConsent
    },
    sucessUpdate() {
      return this.update
    }
    // loadPrequal() {
    //   console.log(this.$store.state.applicationData.loadPrequal)
    //   return this.$store.state.applicationData.loadPrequal
    // }
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  },
  methods: {
    async handleNext() {
      // window.scrollTo({ top: 0, behavior: 'smooth' })
      this.calcPrequalRate = true
      await this.$store.dispatch('calcPrequal')
      this.calcPrequalRate = false
      this.$emit('next', this.$store.state.applicationData.prequalStatus)
    },
    handleBack() {
      // window.scrollTo({ top: 0, behavior: 'smooth' })
      this.$emit('back')
    }
  }
}
</script>

<style scoped></style>
